import React from 'react';

interface ViewProps {
  width?: number;
  height?: number;
}

export const LeftTripleView = ({ width = 66, height = 50 }: ViewProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 67 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1.16666"
      y="0.5"
      width="21"
      height="22"
      rx="1.5"
      stroke="#333745"
      strokeDasharray="3 3"
    />
    <rect x="3.16666" y="2.49997" width="17" height="18" rx="2" fill="#F3F4F6" />
    <path
      d="M8.0408 12.5044C8.10718 12.3979 8.19948 12.3101 8.30903 12.2493C8.41858 12.1884 8.54177 12.1565 8.66701 12.1565C8.79226 12.1565 8.91545 12.1884 9.025 12.2493C9.13454 12.3101 9.22685 12.3979 9.29323 12.5044L11.6666 16.312H5.66666L8.04006 12.5044H8.0408Z"
      fill="#DDE0E4"
    />
    <path
      d="M12.8061 9.21566C12.8674 9.09266 12.9617 8.98921 13.0784 8.91691C13.1951 8.8446 13.3295 8.8063 13.4667 8.8063C13.6038 8.8063 13.7383 8.8446 13.855 8.91691C13.9716 8.98921 14.0659 9.09266 14.1272 9.21566L17.6667 16.3126H9.26669L11.3669 12.1015L12.8069 9.21566H12.8061Z"
      fill="#DDE0E4"
    />
    <path
      d="M8.66706 10.2974C9.66137 10.2974 10.4674 9.4893 10.4674 8.49245C10.4674 7.49561 9.66137 6.6875 8.66706 6.6875C7.67275 6.6875 6.8667 7.49561 6.8667 8.49245C6.8667 9.4893 7.67275 10.2974 8.66706 10.2974Z"
      fill="#DDE0E4"
    />
    <rect
      x="27.1667"
      y="0.5"
      width="39"
      height="22"
      rx="1.5"
      stroke="#333745"
      strokeDasharray="3 3"
    />
    <rect
      x="1.16666"
      y="27.5"
      width="65"
      height="22"
      rx="1.5"
      stroke="#333745"
      strokeDasharray="3 3"
    />
  </svg>
);
